/* @ngInject */
function PlanLimitExceedInterceptor($injector, $q, errorMessages) {
  return {
    responseError: async function (rejection) {
      if (
        rejection.status === 400 &&
        rejection.data === errorMessages.plans.planLimitExceeded
      ) {
        const ModalsManager = $injector.get("ModalsManager");
        ModalsManager.openUsersLimitExceededModal();
      } else if (
        rejection.status === 400 &&
        rejection.data === errorMessages.newQuoteLimitExceeded
      ) {
        const ModalsManager = $injector.get("ModalsManager");
        ModalsManager.openQuotesMonthLimitExceededModal();
      }

      return $q.reject(rejection);
    },
  };
}

export default PlanLimitExceedInterceptor;
